import { db, EMAIL_FUNCTION, ELASTIC_SEARCH_SHOPS_INDEX} from '../../../firebase'
import axios from 'axios'
import {findShopFromNocoDB} from '../../../firebase'
import router from '../../../router'

const Shops = db.collection('shops')

export const getRef = (id) => Shops.doc(id)

export const getUserShops = (uid) => Shops.where('owner_id', '==', uid)

export const find =  async domain => {

    try {
        const response = await findShopFromNocoDB({domain})
        return response
    } catch(e){
        return {
            error: 'Something went wrong'
        }
    }

}


export const sendVerifyShopEmail = (code, email) => {
    return axios.post(EMAIL_FUNCTION, {
            email,
            subject: `Crossprom Verification code`,
            templateData: {
                code
            },
            templateName: 'verifyShop'
        })
}

export const getById = async shopId => {
    const response = await Shops.doc(shopId).get()
    if(!response.exists) {
        return {}
    }
    return {
        id: response.id,
        ...response.data()
    }
}


export const getByUrl = async url => {
    const response = await Shops.where('domain','==',url).get()
    return response.docs && response.docs[0]
}

export const save = data => {
    return Shops.add(data)
}

export const update = data => {
    return db
        .collection('shops')
        .doc(data.id)
        .update(data)
}

export const set = (docRef, data) => {
    return docRef.set(data, {merge: true})
}

export const getShopsByIds = (ids, size) => {
    const searchData = {
        size,
        query: {
            ids : {
                values : ids
            }
        }
    }
    return axios.post(`https://search.crossprom.com/${ELASTIC_SEARCH_SHOPS_INDEX}/_search`, searchData)
}

export const getShopsList = (userId, filters, page, shopCategory, randomSeed) => {
    const PER_PAGE = 12
    const searchData = {}
    searchData.from = (page - 1) * PER_PAGE
    searchData.size = PER_PAGE

    if(filters.alexaRankOrder === null && !filters.monthlySales.length && !filters.category.length) {
        searchData.query = {
            "function_score": {
                "query": {
                    bool: {
                        must_not: [
                            {
                                exists: {
                                    field: 'hidden'
                                },
                            },
                            {
                                term: { 
                                    "owner_id.keyword": userId,
                                }
                            }
                        ],
                    }
                },
                "boost": "5", 
                "functions": [
                    {
                        "filter": {
                            bool: {
                                "must_not": { 
                                    term: {
                                        "category.keyword": shopCategory
                                    }
                                } 
                            }
                        },
                        "random_score":  {"seed": randomSeed},
                        "weight": 50
                    },
                    {
                        "filter": { 
                            bool: {
                                must: {
                                    "term": { "category.keyword": shopCategory }
                                }
                            } 
                        },
                        "random_score":  {"seed": randomSeed}, 
                        "weight": 50
                    },
                ],
                "boost_mode": "replace",
                "score_mode": "sum",
            }
        }
    
        return axios.post(`https://search.crossprom.com/${ELASTIC_SEARCH_SHOPS_INDEX}/_search`, searchData)
    }


    if(filters.alexaRankOrder !== null) {
        searchData.sort = [
            {
                alexa_rank: { 
                    order: filters.alexaRankOrder, 
                    mode: 'max' 
                } 
            },
        ];
    }

    searchData.query = {
        bool: {
            must_not: [
                {
                    exists: {
                        field: 'hidden'
                    },
                },
                {
                    term: { 
                        "owner_id.keyword": userId,
                    }
                }
            ],
        }
    }

    const mustParams = []
    const shouldParams = []

    if(filters.category.length) {
        mustParams.push({
            "terms": {
                "category.keyword": filters.category
            }
        })
    }

    if(filters.monthlySales.length) {

        const monthlySales = filters.monthlySales.map(item => {
            return {
                range: {
                    "estimated_monthly_sales": {
                        gte: item[0],
                        lte: item[1]
                    }
                }
            }
        })
        shouldParams.push(...monthlySales)
    }

    if(mustParams.length) {
        searchData.query.bool.must = mustParams
    }

    if(shouldParams.length) {
        searchData.query.bool.filter = {
            bool: {
                should: [
                    ...shouldParams
                ]
            }
        }
    }
    
    return axios.post(`https://search.crossprom.com/${ELASTIC_SEARCH_SHOPS_INDEX}/_search`, searchData)
        
}